import { AxiosResponse } from "axios";
import { UploadRequestOption } from "rc-upload/lib/interface";

import models from "@aeo/core/models";
import { GenericObject } from "@aeo/core/types/common";
import { stringifyUrl } from "@aeo/core/api/utils";

import { apiAxios } from "./axios/apiAxios";

export const documents = (path: string) => ({
  get: async (query: GenericObject = {}) => {
    const url = stringifyUrl(path, query);
    const { data } = await apiAxios.get<models.WithResults<models.Attachment>>(
      url,
    );
    return data;
  },
  upload: async (option: UploadRequestOption<models.Attachment>) => {
    try {
      const formData = new FormData();
      if (option.file instanceof Blob) {
        formData.append(
          option.filename || "",
          option.file,
          (option.file as any).name,
        );
      } else {
        formData.append(option.filename || "", option.file);
      }
      formData.append("title", option.file.name);
      const { data } = await apiAxios.post<
        any,
        AxiosResponse<models.Attachment>
      >(path, formData, {
        onUploadProgress: (e: ProgressEvent) => {
          option.onProgress &&
            option.onProgress({
              ...e,
              percent: e.total ? (e.loaded / e.total) * 100 : 0,
            });
        },
      });
      option.onSuccess && option.onSuccess(data, {} as XMLHttpRequest);
      return data;
    } catch (error: any) {
      option.onError && option.onError(error, undefined);
      return null;
    }
  },
  delete: async (id: number) => {
    return await apiAxios.delete(`${path}/${id}`);
  },
});

export const getDownloadFile = async (url: string): Promise<Blob> => {
  const { data } = await apiAxios.get(url, {
    responseType: "blob",
  });

  return data;
};
